import React, { useState, useEffect, useCallback } from "react";
import { Table, Button, Typography, Row, Col, Image } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { DEFAULT_PROFILE_IMAGE } from "../../../common/awsBucket";
import ActionsColumn from "./components/ActionsColumn";
import AdvancedSearchForm from "../../../common/SearchForm";

const { Title, Link } = Typography;

function InsuranceCatalog(props) {
  const [searchOption, setSearchOption] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const onDeleteSpotFinance = async (payloadObj) => {
    await props.updateVendorMedSurgeryInsurance(payloadObj);
    await props.getAllVendorMedSurgerylnsurance(undefined, 20, currentPage);
  };

  const renderData = useCallback(
    (currentPage) => {
      props.getAllVendorMedSurgerylnsurance(undefined, 20, currentPage);
    },
    [props.getAllVendorMedSurgerylnsurance]
  );

  useEffect(() => {
    renderData(currentPage);
  }, [renderData, currentPage]);

  const columns = [
    {
      title: "Insurance Name",
      key: "name",
      dataIndex: "name",
      render: (_, columnData) => (
        <Row>
          <Col span={2} className="table-fc-image">
            <Image
              src={
                columnData.pic_url ? columnData.pic_url : DEFAULT_PROFILE_IMAGE
              }
              preview={false}
            />
          </Col>
          <Col span={14} offset={1}>
            <div className="table-fc-name">{columnData.name}</div>
            <div className="table-fc-status">
              {columnData.status ? (
                <span className="activate">Active</span>
              ) : (
                <span className="inActivateNotverified">Blocked</span>
              )}
            </div>
            {columnData.link_url ? (
              <div className="view-details">
                <Link
                  target="_blank"
                  href={`//${columnData.link_url.replace(/^https?:\/\//, "")}`}
                >
                  VIEW LINK
                </Link>
              </div>
            ) : null}
          </Col>
        </Row>
      ),
    },
    {
      title: "Country",
      key: "category",
      render: (_, columnData) => <div>{`${columnData.country}`}</div>,
    },
    {
      title: "Action",
      key: "actions",
      render: (_, columnData) => (
        <ActionsColumn
          columnData={columnData}
          onDeleteSpotFinance={onDeleteSpotFinance}
        />
      ),
    },
  ];

  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join("&");
    props.getAllVendorMedSurgerylnsurance(queryString, 20, currentPage);
  };

  const toggleSearch = () => {
    setSearchOption(!searchOption);
  };

  return (
    <div>
      <Row gutter={[0, 16]}>
        <Col className="gutter-row section-heading" span={12} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            Insurance
          </Title>
        </Col>
        <Col className="gutter-row" span={9} offset={0}></Col>
        <Col className="gutter-row header-buttons" span={3} offset={0}>
          <Button
            className={`${
              searchOption === true ? "search-open" : "search-close"
            } search-toggle-button`}
            onClick={() => toggleSearch()}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
      </Row>
      {searchOption === true ? (
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Insurance"
          formItems={[
            {
              key: "q[name_cont]",
              label: "Insurance Name",
            },
            {
              key: "q[country_cont]",
              label: "Country",
            },
          ]}
        />
      ) : (
        ""
      )}
      <Table
        className="list_table"
        dataSource={props.results ? props.results.data : null}
        pagination={{
          pageSize: 20,
          total: props.results?.total_count,
          showSizeChanger: false,
        }}
        columns={columns}
        scroll={{ x: 800 }}
        rowKey="spot_finance_id"
        onChange={(e) => {
          setCurrentPage(e.current);
        }}
      />
    </div>
  );
}

export default InsuranceCatalog;
